import api from '../api';
import { unwrapApiResponse } from '@/utils/api-response.util';
import { TemplateStatsDto } from '@/types/questionnaire-analytics';

export const getTemplateStats = async (templateId: number): Promise<TemplateStatsDto> => {
  const response = await api.get(`/admin/questionnaire-analytics/templates/${templateId}`);
  return unwrapApiResponse<TemplateStatsDto>(response.data);
};
